import React from 'react';
import {TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";

const Input=({label,value,changeValue,type="text",maxLines=false,styleCSS={padding:"10px"},Busqueda=false })=>
{
    return <TextField
    value={value}
    InputProps={ Busqueda && {startAdornment: (
        <InputAdornment>
          <IconButton>
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      ) }}
    fullWidth style={styleCSS}
    label={label} 
    multiline={maxLines} 
    rowsMax={maxLines} type={type}  
    variant="outlined" defaultValue={value} 
    onChange={e => 
        {
            if(type==="number")
            {
                changeValue(Number(e.target.value))
            }
            else
            {
                changeValue(e.target.value)
            }
        }}
    />
}

export default Input
